import color1 from '../Assets/Images/WorkoutPlanBackgrounds/bg1/overlay-color@3x.png';
import color2 from '../Assets/Images/WorkoutPlanBackgrounds/bg2/overlay-color@3x.png';
import color3 from '../Assets/Images/WorkoutPlanBackgrounds/bg3/overlay-color@3x.png';
import color4 from '../Assets/Images/WorkoutPlanBackgrounds/bg4/overlay-color@3x.png';
import color5 from '../Assets/Images/WorkoutPlanBackgrounds/bg5/overlay-color@3x.png';
import color6 from '../Assets/Images/WorkoutPlanBackgrounds/bg6/overlay-color@3x.png';
import color7 from '../Assets/Images/WorkoutPlanBackgrounds/bg7/overlay-color@3x.png';
import color8 from '../Assets/Images/WorkoutPlanBackgrounds/bg8/overlay-color@3x.png';
import color9 from '../Assets/Images/WorkoutPlanBackgrounds/bg9/overlay-color@3x.png';
import color10 from '../Assets/Images/WorkoutPlanBackgrounds/bg10/overlay-color@3x.png';
import color11 from '../Assets/Images/WorkoutPlanBackgrounds/bg11/overlay-color@3x.png';
import color12 from '../Assets/Images/WorkoutPlanBackgrounds/bg12/overlay-color@3x.png';
import color13 from '../Assets/Images/WorkoutPlanBackgrounds/bg13/overlay-color@3x.png';
import color14 from '../Assets/Images/WorkoutPlanBackgrounds/bg14/overlay-color@3x.png';

const overlays = [
    { type: 1, overlay: color1 },
    { type: 2, overlay: color2 },
    { type: 3, overlay: color3 },
    { type: 4, overlay: color4 },
    { type: 5, overlay: color5 },
    { type: 6, overlay: color6 },
    { type: 7, overlay: color7 },
    { type: 8, overlay: color8 },
    { type: 9, overlay: color9 },
    { type: 10, overlay: color10 },
    { type: 11, overlay: color11 },
    { type: 12, overlay: color12 },
    { type: 13, overlay: color13 },
    { type: 14, overlay: color14 },
];

export const generateRandomBackground = (base = overlays.length) => {
    let index = Math.floor(Math.random() * base) + 1;

    return new Promise(resolve => {
        resolve(overlays[index]);
    });
};



// WEBPACK FOOTER //
// ./src/Utils/workoutPlanBackgroundRandomizer.js